import React, { useState } from 'react';
import './PrivacyPolicy.css'; // Import the custom CSS for styling

const PrivacyPolicy = () => {
  const [sections, setSections] = useState([
    { title: 'Objective', description: '' },
    { title: 'Qualifications', description: '' },
    { title: 'The Data That We Gather', description: '' },
    { title: 'How We Could Apply the User Data', description: '  ' },
    { title: 'Web Beacons and Cookies', description: '' },
    { title: 'Disclosures and Information Exchange', description: '' },
    { title: 'Linked Services', description: '' },
    { title: 'Regulation of Law and Authority', description: '' },
    { title: 'Updates', description: '' },
  ]);

  const [newSection, setNewSection] = useState({ title: '', description: '' });

  const handleSectionChange = (index, field, value) => {
    const updatedSections = [...sections];
    updatedSections[index][field] = value;
    setSections(updatedSections);
  };

  const handleNewSectionChange = (field, value) => {
    setNewSection({ ...newSection, [field]: value });
  };

  const addNewSection = () => {
    if (newSection.title && newSection.description) {
      setSections([...sections, newSection]);
      setNewSection({ title: '', description: '' });
    } else {
      alert('Please fill in both Title and Description for the new section.');
    }
  };

  const updatePrivacyPolicy = () => {
    console.log('Updated Privacy Policy:', sections);
    alert('Privacy Policy updated successfully!');
  };

  return (
    <div className="privacy-container">
      <h2>Update Privacy Policy</h2>
      {sections.map((section, index) => (
        <div key={index} className="section">
          <label>{section.title}</label>
          <textarea
            value={section.description}
            onChange={(e) => handleSectionChange(index, 'description', e.target.value)}
          />
        </div>
      ))}
      <div className="new-section">
        <input
          type="text"
          placeholder="Enter Section Title"
          value={newSection.title}
          onChange={(e) => handleNewSectionChange('title', e.target.value)}
        />
        <textarea
          placeholder="Enter Section Description"
          value={newSection.description}
          onChange={(e) => handleNewSectionChange('description', e.target.value)}
        />
      </div>
      <button className="add-section-btn" onClick={addNewSection}>Add New Section</button>
      <button className="update-btn" onClick={updatePrivacyPolicy}>Update Privacy Policy</button>
    </div>
  );
};

export default PrivacyPolicy;
